import APIconButton from "./APIconButton";
import { useEffect, useState } from "react";
import { ButtonProps } from "@chakra-ui/react";
import { PlaySound } from "./APAssetAtlas";
import { useVocabIntl } from "../hooks/useVocabTranslation";

interface AudioPlayerProps extends ButtonProps {
  file: string;
  disableShadow?: boolean;
  tabIndex?: number;
  autoPronounce?: boolean;
}

export default function APAudioPlayer({
                                        file,
                                        disableShadow,
                                        tabIndex,
                                        autoPronounce = false,
                                        ...other
                                      }: AudioPlayerProps) {

  const { getFormattedString } = useVocabIntl();

  const [playing, setPlaying] = useState<boolean>(false);
  const [audio, setAudio] = useState<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (file) {
      const audio = new Audio(file);

      const onPlay = () => {
        setPlaying(true)
      }
      const onEnd = () => {
        setPlaying(false)
      }
      audio.addEventListener("play", onPlay);
      audio.addEventListener("ended", onEnd);
      audio.playbackRate = 1;

      if (autoPronounce) {
        audio.play()
      }

      setAudio(audio);
      return () => {
        audio.removeEventListener("play", onPlay);
        audio.removeEventListener("ended", onEnd);
      }
    }

  }, [file]);

  return (
    <APIconButton
      onClick={() => audio?.play()}
      disabled={!file || playing}
      tabIndex={tabIndex}
      aria-label={getFormattedString('aria-label-listen-word')}
      {...other}>
      <PlaySound />
    </APIconButton>
  );
}
